<template>
    <v-dialog v-model="dialog" width="100%" max-width="500"  style="position: relative" >
        <v-sheet height="500" style="position: relative">
            <div class="map-wrapper">
                <div class="input-wrapper">

                    <div class="text">
                        <input
                                @keyup="debouncedSearchByText"
                                @focus="onInputFocus"
                                ref="searchInput"
                                type="text"
                                v-model="searchText"
                                :placeholder="searchPlaceholderText || 'Buscar direccion'"/>
                        <i class="clear-icon" v-if="searchText" @click="clear">&times;</i>
                    </div>

                    <div class="text-search-results" v-if="showTextResults">
                        <p v-if="textResults.length === 0" class="no-results">Sin resultados</p>
                        <div @click="setCurrentPosition(item)" class="result-item" v-for="(item, i) in textResultsMap" :key="i">
                            {{item.text}}
                        </div>
                    </div>
                </div>

<!--                <MglMap
                        :accessToken="accessToken"
                        :mapStyle="mapStyle"
                        :zoom="14.5"
                        :scrollZoom="{around: 'center' }"
                        :bearing="2"
                        :center="currentCenter"
                        :maxBounds="maxBounds"
                        :pitch="30"
                        @load="onMapLoad"
                        @click="showTextResults=false"
                        @moveend="onMapMoveEnds"
                >
                    <MglGeolocateControl
                            :positionOptions="{ enableHighAccuracy: true, timeout: 6000}"
                            position="top-right"
                            :showUserLocation="false" />

                </MglMap>-->

                <div class="marker"  pointer-events="none">
                    <slot name="marker">
                        <div style="font-size: 2em">&#9673;</div>
                    </slot>
                </div>

                <div class="confirm-button">
                    <div id="btn-wrapper" class="button-wrapper" @click="onConfirm">
                        <slot name="confirm-button">
                            <button class="default-button">{{buttonLabel || 'Aceptar'}}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </v-sheet>

    </v-dialog>

</template>

<script>

  /*  import { MglMap, MglGeolocateControl } from "vue-mapbox";*/
    import {debounce} from '@/utils/Common'
   /* import 'mapbox-gl/dist/mapbox-gl.css'*/

    export default{
        components: {
          /*  MglMap,
            MglGeolocateControl*/
        },
        mounted(){
            var vm = this

            if(vm.defaultAddress){
                vm.setCurrentPosition(vm.defaultAddress)
            }else{
                const initialCenter = this.center ||  [-71.59320069385319, -33.033599221769556]
                vm.selectedCenter = initialCenter
                vm.currentCenter = initialCenter
            }

        },
        data(){
            return {
                dialog: false,
                geoCodingEndpoint: 'https://maps.googleapis.com/maps/api/geocode',
                selectedCenter: [],
                selectedAddress: '',
                currentCenter: [],
                searchText: '',
                textResults: [],
                showTextResults: false,
                selectedResult: [],
                avoidNextSearchByPoint: false,
                loading: true
            }
        },
        props: {
            buttonLabel:{
                type: String,
                required: false
            },
            searchPlaceholderText: {
                type: String,
                required: false
            },
            accessToken: {
                type: String,
                required: true
            },
            googleApiKey: {
                type: String,
                required: true
            },
            mapStyle: {
                type: String,
                required: true
            },
            maxBounds: {
                type: Array,
                required: false
            },
            confirmButton: {
                type: Boolean,
                required: false
            },
            defaultAddress:{
                type: Object
            },
            center: {
                type: Array,
                required: false
            },
            country: {
                type: String,
                required: false
            }
        },
        methods: {
            show(){
                this.dialog = true
            },
            hide(){
                this.dialog = false
            },
            onConfirm(){
                var vm = this
                if(vm.loading) return
                vm.$emit('confirm', vm.geoLocation)
            },
            clear(){
                var vm = this
                vm.searchText = ''
                vm.showTextResults = false
                vm.textResults = []
                vm.$refs.searchInput.focus()
            },
            onInputFocus(){
                var vm = this
                if(vm.textResults.length > 0){
                    vm.showTextResults = true
                }
            },
            goTo(center = []){
                var vm = this
                if(!vm.mapActions) return
                vm.mapActions.flyTo({
                    center: center,
                    zoom: 14.5,
                    speed: 10
                })
            },
            setCurrentPosition(searchResultItem){
                var vm = this
                vm.avoidNextSearchByPoint = true
                vm.selectedAddress = searchResultItem.text
                vm.selectedCenter = searchResultItem.center
                vm.goTo(searchResultItem.center)
                vm.showTextResults = false
            },
            onMapMoveStarts(){
                this.loading = true
            },
            onMapMoveEnds(){

                var vm = this
                vm.loading = false
                const center = this.map.getCenter()

               const selectedCenter = [
                    center.lng,
                    center.lat
                ]

                vm.selectedCenter = selectedCenter
                if(!vm.avoidNextSearchByPoint){
                    vm.searchByPoint(selectedCenter)
                }

                vm.avoidNextSearchByPoint = false

            },
            onMapLoad({map, component}){
                var vm = this
                vm.loading = false
                vm.map = map;
                vm.mapActions = component.actions
            },
            async searchByPoint(center = []){

                var vm = this
                vm.loading = true
                var query = `latlng=${center[1]},${center[0]}&key=${vm.googleApiKey}`
                const response = await fetch(`${vm.geoCodingEndpoint}/json?${query}`)
                vm.loading = false
                if(response.ok){
                    const json = await response.json()
                    if(json.results.length > 0){
                        vm.selectedAddress = json.results[0].formatted_address
                        vm.textResults = []
                    }
                }

            },
            debouncedSearchByText: debounce(function(){
                    this.searchByText()
                }, 500),
            async searchByText(){

                var vm = this
                if(vm.searchText.length < 3) return
                vm.selectedAddress = ''
                vm.showTextResults = false
                var query = `region=cl&address=${vm.searchText}&key=${vm.googleApiKey}`

                vm.loading = true
                const response = await fetch(`${vm.geoCodingEndpoint}/json?${query}`)
                vm.loading = false
                if(response.ok){
                    const json = await response.json()
                    vm.textResults = json.results
                    vm.showTextResults = true
                    return
                }

                vm.textResults = []

            }
        },
        computed: {
            geoLocation(){
                var vm = this
                return {
                    address: vm.selectedAddress || vm.searchText,
                    center: vm.selectedCenter
                }
            },
            textResultsMap(){
                return this.textResults.map((item) => {
                    return {
                        'text': item.formatted_address,
                        'center': [item.geometry.location.lng, item.geometry.location.lat]
                    }
                })
            }
        },
        watch:{
            defaultAddress(val){

                if(val){
                    this.setCurrentPosition(val)
                }
            },
            loading(val){
                var btn = document.getElementById("btn-wrapper")
                if(!btn) return
                btn.firstChild.disabled = val
            },
            selectedAddress(val){
                this.searchText = val
            },
            center(val){
                var vm = this
                vm.currentCenter = val
                vm.selectedCenter = val
                vm.$nextTick(function(){
                    vm.searchByPoint(val)
                })
            }
        },
        created(){
            this.map = null;
        }
    }

</script>

<style scoped>

    .dialog{
        position: relative
    }

    .input-wrapper{
        position: absolute;
        width: 210px;
        top: 7px;
        left: 10px;
        z-index: 10;
    }

    .input-wrapper .text .clear-icon{
        position: absolute;
        right: 0;
        top: 0;
        background-color: #fff;
        padding: 0 10px;
        margin: 2px;
        font-size: 1.5em;
        cursor: pointer;
    }

    .input-wrapper .text{
        width: 100%;
        background-color: #fff;
        text-align: start;
        padding: 5px;
        border-radius: 5px;
        border: 2px solid rgba(0,0,0,.3);
        box-shadow: 5px 5px 20px #00000047;
        transition: .3s all;
    }
    .input-wrapper .text input{
        width: 205px;
        padding: 5px;
        margin-left: 2px;
        height: 22px;
        border: none;
    }

    .input-wrapper input:focus{
        outlined: none
    }

    .text-search-results{
        width: 238px;
        border-radius: 3px;
        text-align: left;
        font-size: .8em;
        margin-top: 3px;
        padding: 5px 5px 0 5px;
        background-color: rgba(255,255,255,.9);
        -webkit-box-shadow: 3px 3px 20px #00000057;
        box-shadow: 3px 3px 20px #00000057;
        position: relative;
        z-index: 10;
    }

    .text-search-results .result-item{
        width: 100%;
        height: 30px;
        border-bottom: 1px solid #ccc;
        padding: 8px 0;
        margin-bottom: 5px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: .3s all;
    }

    .text-search-results .result-item:hover{
        cursor: pointer;
        background-color: #fff;
    }

    .text-search-results .result-item:last-child{
        border-bottom: none;
    }

    @media only screen and (min-width: 412px) {

        .text-search-results {
            width: 332px;
        }

        .input-wrapper{
            width: 340px;
        }

        .input-wrapper .text input{
            width: 305px;
        }

    }


    .map-wrapper{
        position: relative;
        height: 100%;
        width: 100%;
    }

    .confirm-button{
        position: absolute;
        bottom:40px;
        text-align: center;
        left: 0;
        width: 100%
    }

    .confirm-button .button-wrapper{
        width: fit-content;
        padding: 5px;
        margin: auto;
    }

    .default-button{
        width: 250px;
        height: 35px;
        box-shadow: 5px 5px 20px #00000094;
        border-radius: 30px;
        border: 1px solid #000;
        text-transform: uppercase;
        padding: 5px;
        background-color: #000;
        color: #fff;
        outlined: none;
        transition: .3s all;
    }

    .default-button:hover{
        cursor: pointer;
        border: 1px solid #fff;
        background-color: #232323;
    }


    .marker-wrapper{
        position: absolute;
        top: 0;
        height: 100%;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .marker{
        height: 50px;
        width: 50px;
        position: absolute;
        left: 50%;
        margin-left: -25px;
        top: 50%;
        margin-top: -25px;
    }

    .no-results{
        margin: 0 10px;
        padding: 5px 0 10px 0;
    }

</style>
